import {
  Package, Clock, BarChart3, Brain, Megaphone, Calculator,
  Truck, Shield, Headphones, Share2, Target,
} from "lucide-react";

export const ICONS = {
  Package, Clock, BarChart3, Brain, Megaphone, Calculator,
  Truck, Shield, Headphones, Share2, Target,
};
